import {parsePhoneNumber} from "react-phone-number-input"
import {get} from "lodash"
import client from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"

import {Mfa as MfaType, MfaSetup} from "@irati/types"
import mfa from "../utils/mfa"
import mfaHasFlagQuery, {mfaHasFlagKey} from "./queries/mfaHasFlag"
import {mfaIpWhitelistedQuery, mfaIpWhitelistedKey} from "./queries/mfaIpWhitelisted"
import {mfaHasFlagShortTermQuery, mfaHasFlagShortTermKey} from "./queries/mfaHasFlagShortTerm"
import mfaRequestQuery, {mfaRequestKey} from "./queries/mfaRequest"
import mfaValidateMutation, {mfaValidateKey} from "./mutations/mfaValidate"
import mfaGetUserQuery, {mfaGetUserKey} from "./queries/mfaGetUser"
import mfaDeleteUserMutation, {mfaDeleteUserKey} from "./mutations/mfaDeleteUser"
import mfaSetupMutation, {mfaSetupKey} from "./mutations/mfaSetup"
import tokens from "./tokens"
import mfaErrorHandler from "./errors/mfaErrorHandler"

class MFA extends PBService {
  async hasFlag(): Promise<boolean> {
    const {data} = await client.query({query: mfaHasFlagQuery, fetchPolicy: "network-only"})
    return data[mfaHasFlagKey]
  }

  async isIpWhitelisted(): Promise<boolean> {
    const {data} = await client.query({query: mfaIpWhitelistedQuery, fetchPolicy: "network-only"})
    return data[mfaIpWhitelistedKey]
  }

  async hasFlagShortTerm(): Promise<boolean> {
    const {data} = await client.query({query: mfaHasFlagShortTermQuery, fetchPolicy: "network-only"})
    return data[mfaHasFlagShortTermKey]
  }

  async request(): Promise<MfaType> {
    const {data} = await client.query({query: mfaRequestQuery, fetchPolicy: "network-only"})
    return data[mfaRequestKey]
  }

  async validate(code: string): Promise<boolean> {
    const variables = {code}
    try {
      const {data} = await client.mutate({mutation: mfaValidateMutation, variables})
      const {success, accessToken} = data[mfaValidateKey]
      await tokens.replace({accessToken})
      mfa.complete()
      return success
    } catch (e) {
      throw e
    }
  }

  async setup(phoneNumber: string): Promise<MfaType> {
    const country = get(parsePhoneNumber(phoneNumber), "country") || "GB"
    const variables = {phoneNumber, country}
    const {data} = await client.mutate({mutation: mfaSetupMutation, variables, fetchPolicy: "no-cache"})
    return data[mfaSetupKey]
  }

  async getUser(userId?: string): Promise<MfaSetup | null> {
    const variables = {userId}
    const {data} = await client.query({query: mfaGetUserQuery, variables, fetchPolicy: "network-only"})
    return data[mfaGetUserKey]
  }

  async deleteUser(userId: string): Promise<boolean> {
    const variables = {userId}
    const {data} = await client.mutate({mutation: mfaDeleteUserMutation, variables, fetchPolicy: "no-cache"})
    return data[mfaDeleteUserKey]
  }
}

const mfaService = new MFA({errorHandlers: [mfaErrorHandler]})

export default mfaService
